module.exports = __webpack_public_path__ + "static/Ic_Brance-d889a76cad7fe391a3a1268941091bde.svg";